import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { DoubleArrowDown } from "assets";
import { format, parseISO } from "date-fns";
import { HistoryDetails } from "interfaces";
import { Link } from "react-router-dom";
import { readableStatus, toPrecision, transferStatusColor } from "utils";

interface IProps {
  direction: "in" | "out";
  amount: number | string;
  description: string;
  status: HistoryDetails["transferStatus"];
  // status: "TransferMade" | "TransferFailed" | "TransferCancelled" | "TransferPending";
  crypto: string;
  createdAt: string;
  _id: string;
}
const TransferCard = ({ amount, description, status, direction, crypto, createdAt, _id }: IProps) => {
  return (
    <Link to={`/transfer-history/${_id}`}>
      <Flex
        bg="#FBFBFB"
        borderRadius="5px"
        mb="12px"
        justifyContent="space-between"
        alignItems="center"
        padding="10px 9px"
        gridTemplateColumns="3fr 1fr 1.5fr"
      >
        <Flex gridGap="13px" alignItems="center">
          <Center
            width={{ base: "24px", "1sm": "29px" }}
            height={{ base: "24px", "1sm": "29px" }}
            borderRadius="full"
            bg={direction === "in" ? "#E2F2DA" : "linear-gradient(0deg, rgba(237, 28, 0, 0.5), rgba(237, 28, 0, 0.5)), #FFFFFF;"}
          >
            {direction === "in" ? <DoubleArrowDown /> : <DoubleArrowDown />}
          </Center>

          <Box>
            <Text fontSize={{ base: "12px", "1sm": "18px" }} fontWeight="700" mb={{ base: "2px", "1sm": "4px" }}>
              {toPrecision(+(amount ?? 0), crypto.toLowerCase() ?? "btc")}
            </Text>

            <Text fontSize={{ base: "10px", "1sm": "14px" }} fontWeight="400">
              {description}
            </Text>
          </Box>
        </Flex>

        <Text fontSize={{ base: "10px", "1sm": "14px" }}>{format(parseISO(createdAt), "dd-MM-yyyy")}</Text>

        <Text textAlign="left" fontSize={{ base: "12px", "1sm": "14px" }} fontWeight="600" color={transferStatusColor(status)}>
          {readableStatus(status)}
        </Text>
      </Flex>
    </Link>
  );
};

export default TransferCard;
